// extracted by mini-css-extract-plugin
module.exports = {"wrap":"StarRating_wrap__jiJ1F","empty":"StarRating_empty__DSz1q","filled":"StarRating_filled__qK9BJ"};